import { Component, Input } from '@angular/core';
import { PurchasedProductInterface } from 'outshared-lib';
import { InsuranceStartDateDataComponent } from './insurance-start-date-data';

@Component({
    standalone: true,
    selector: 'ins-insurance-start-date',
    templateUrl: './insurance-start-date.component.html',
    imports: [
        InsuranceStartDateDataComponent
    ]
})
export class InsuranceStartDateComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
}
